module.exports = "<div class=\"type\">\n  <div>\n  {{question_index}}<span class=\"mandatory\" *ngIf=\"is_mandt\">*</span>. {{question_name}}\n  </div>\n  <div>\n  {{question_name_second}}\n  </div>\n  <div class=\"doc_input_container\">\n    <button class=\"select_doc\">SELECT DOCUMENT</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/questions-type/doc-type/doc-type.component.html
// module id = ./src/app/questions-type/doc-type/doc-type.component.html
// module chunks = main